import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { useIsDesktop } from '@shared/util/hooks';
import { MonthOptionsDesktop } from './MonthOptionsDesktop';
import { MonthOptionsMobile } from './MonthOptionsMobile';

export function MonthOptions(props: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <MonthOptionsDesktop {...props} />;
  } else {
    return <MonthOptionsMobile {...props} />;
  }
}
